import { createContext } from 'react';
import type { AuthUser } from 'aws-amplify/auth';

export interface AuthContextValue {
  /** The currently authenticated Cognito user, or null while loading / unauthenticated. */
  user: AuthUser | null;
  /** True while the initial auth check is in progress. */
  isLoading: boolean;
  /** True once a valid session has been confirmed. */
  isAuthenticated: boolean;
  /** Returns the current access token string (refreshes silently if needed). */
  getAccessToken: () => Promise<string | null>;
  /** Redirect to Cognito hosted UI for login. */
  login: () => Promise<void>;
  /** Sign out and clear session. */
  logout: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextValue | undefined>(undefined);
